var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { put, takeEvery } from 'redux-saga/effects';
import { findKey, mapValues, forIn, reduce, get } from 'lodash';
import { getStore } from '../store';
import * as actions from '../actions';
/**
 * 在页面启动时调用的saga，此时为切换分页至第一页
 */

export function initComponentSagas() {
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        return [4
        /*yield*/
        , takeEvery(actions.GET_SUCCESS, initEditFormSaga)];

      case 1:
        _a.sent();

        return [2
        /*return*/
        ];
    }
  });
}
/**
 * <generator函数> 数据加载后进行 EditForm 数据初始化
 */

function initEditFormSaga(action) {
  var state, entity_1, payload_1, _a, entityId, properties, componentId, fields_1, error_1;

  return __generator(this, function (_b) {
    switch (_b.label) {
      case 0:
        _b.trys.push([0, 2,, 3]);

        state = getStore().getState();
        entity_1 = action.entity, payload_1 = action.payload;
        _a = entity_1, entityId = _a.id, properties = _a.metainfo.properties;
        componentId = findKey(state.components, {
          entityId: entityId,
          type: 'EditForm',
          loaded: false
        });

        if (componentId === undefined) {
          return [2
          /*return*/
          ];
        }

        fields_1 = mapValues(properties, function (_property, name) {
          return payload_1[name];
        });
        return [4
        /*yield*/
        , put(actions.formInitAction(componentId, {
          type: 'EditForm',
          entityId: entityId,
          fields: fields_1,
          loaded: true
        }))];

      case 1:
        _b.sent();

        forIn(properties, function (property, name) {
          reloadPropertyOptions(name, property, entity_1, fields_1);
        });
        return [3
        /*break*/
        , 3];

      case 2:
        error_1 = _b.sent();
        return [3
        /*break*/
        , 3];

      case 3:
        return [2
        /*return*/
        ];
    }
  });
}
/**
 * 重新加载有条件依赖的候选项
 * @param {string} path 属性路径
 * @param {object} property 属性定义
 * @param {object} entity 实体定义
 * @param {object} fields 实体数据
 */


function reloadPropertyOptions(path, property, entity, fields) {
  var options = property.options,
      sourceDefination = property.source;

  if (options && sourceDefination && sourceDefination.dependences) {
    var apiRoot = sourceDefination.apiRoot,
        apiPath = sourceDefination.apiPath;
    var source = {
      apiRoot: apiRoot,
      apiPath: apiPath
    };
    var params = reduce(sourceDefination.dependences, function (values, dependence) {
      values[dependence] = get(fields, dependence);
      return values;
    }, {});
    entity.loadPropertyOptions(path, source, params);
  }

  forIn(property.properties, function (subProperty, subPropertyName) {
    reloadPropertyOptions(path + "." + subPropertyName, subProperty, entity, fields);
  });
}